export default {

    Roles: 'Role|Roles',
};
